import React, { Component } from "react";
import { NavLink } from "react-router-dom";

const PreFooter = () => {
  return (
    <div>
      <div className="section bg-white pb-5 px-5 padding">
        <div className="container">
          <NavLink to="/" className="navbar-brand font-weight-bold">
          
          </NavLink>
          <p class="info">Me as a <strong>Front-end Developer</strong> have the capacity
to bring your vision to life, whether or not you
have programming expertise.</p>
          <a type="button" className="btn btn-outline-primary text-dark font-weight-bold" href="https://www.facebook.com/muhammadhassan.naseer.79">
            Get In touch
          </a>
        </div>
      </div>
    </div>
  );
};

export default PreFooter;
